import React from 'react';
import PropTypes from 'prop-types';
import DownloadTool from './DownloadTool';
import ExportTool from './ExportTool';
import DownloadEmailButton from './DownloadEmailButton';

class ButtonGroup extends React.PureComponent {
  constructor() {
    super();
    this.doneOnClick = () => {
      if (this.props.disabled) {
        return;
      }

      window.ReactCompatibility.saveFreeWriteContent();
      window._track('Share | Im Done Button', `${this.props.documentType} | FreeWrite-Builder${this.props.memberTracking}`);
      window.Share.sendDoneMessage();
      if (this.props.isMember) {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    };

    this.getButtonGroup = this.getButtonGroup.bind(this);
  }

  getButtonGroup() {
    return (
      <div className="btn-group">
        { this.props.showDownloadTool && (
          <DownloadTool
            {...this.props}
          />
        )}
        {this.props.showExportTool && (
          <ExportTool
            {...this.props}
          />
        )}
        {this.props.showDownloadAndEmail && (
          <DownloadEmailButton
            {...this.props}
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="pull-right" >
        {this.props.shared && (<a
          id="doneButton"
          data-loading-text="Notifying Document Owner..."
          data-complete-text="Notification Sent!"
          className="export-tool btn btn-success"
          onClick={this.doneOnClick}
        >
          <i className="icon-white icon-ok" />
          I&apos;m Done
        </a>)}
        {!this.props.shared && this.getButtonGroup()}
      </div>
    );
  }
}

ButtonGroup.defaultProps = {
  disabled: false,
  documentType: '',
  isMember: false,
  memberTracking: '',
  shared: false,
  showDownloadTool: false,
  showExportTool: false,
  showDownloadAndEmail: false,
};

ButtonGroup.propTypes = {
  disabled: PropTypes.bool,
  documentType: PropTypes.string,
  isMember: PropTypes.bool,
  memberTracking: PropTypes.string,
  shared: PropTypes.bool,
  showDownloadTool: PropTypes.bool,
  showExportTool: PropTypes.bool,
  showDownloadAndEmail: PropTypes.bool,
};


export default ButtonGroup;



// WEBPACK FOOTER //
// ./src-react/ExportToolbar/ButtonGroup.jsx